<template>
  <div class="security">
    <AuBreadcrumb :parent-name="$t('router.pages.dashboard')" />
    <Secirity />
  </div>
</template>

<script>
import Secirity from "@/panels/components/Secirity.vue";

export default {
  name: "Security",
  components: {
    Secirity
  }
};
</script>
